// drafts/state.js

import { delFormInitialState } from "../../forms/delForm/delFormState";

export const activeDelDraftsInitialState = {
  tabName: "drafts",
  isLoading: false,
  error: null,
  delMode: null,
  currentDel: null,
  delErrors: null,
  delActiveTab: "projects",
  delShowAll: false,
  rev: 0, // Revision for the autosave hook to refeerence.
  // Drafts created offline with locally generated IDs that the server has not
  // been told about yet. Entries: { delId, jsaId, wasteDisposalId, user }.
  // Persisted so registration retries on reconnect; cleared by ensureDraftCreated.
  pendingDraftCreates: [],
  delForm: delFormInitialState,
};
